/**
 * One label for each homeowner destination, on the phone bar and the desktop tabs.
 * Phone labels stay short and title case. "AI" is the short name for the assistant.
 */

const HOMEOWNER_TAB_LABELS = {
  overview: 'Home',
  tasks: 'Tasks',
  projects: 'Projects',
  vendors: 'Vendors',
  assistant: 'AI',
  documents: 'Documents',
  property: 'Property Details',
  contacts: 'Providers',
  settings: 'More',
  agent: 'Sponsor',
  'home-history': 'Pacarion Home History Report',
};

const HOMEOWNER_DESKTOP_TAB_IDS = [
  'overview',
  'tasks',
  'projects',
  'vendors',
  'assistant',
  'documents',
  'property',
  'contacts',
  'settings',
  'agent',
];

const HOMEOWNER_MORE_LINK_IDS = [
  'vendors',
  'documents',
  'agent',
  'property',
  'contacts',
  'home-history',
];

/** Matches the desktop tab row in ClientDashboardV3. */
const DESKTOP_TAB_FONT_PX = 13;
const DESKTOP_TAB_CHAR_EM = 0.62;
const DESKTOP_TAB_PAD_X_PX = 11;
const DESKTOP_TAB_MIN_PX = 44;
const DESKTOP_TABS_GUTTER_PX = 40;

function homeownerTabs(ids) {
  return (ids || []).map((id) => ({ id, label: HOMEOWNER_TAB_LABELS[id] }));
}

function desktopTabRowWidth() {
  const labels = homeownerTabs(HOMEOWNER_DESKTOP_TAB_IDS).map((tab) => tab.label);
  const row = labels.reduce((sum, label) => {
    const text = label.length * DESKTOP_TAB_FONT_PX * DESKTOP_TAB_CHAR_EM;
    return sum + Math.max(DESKTOP_TAB_MIN_PX, text + (DESKTOP_TAB_PAD_X_PX * 2));
  }, 0);
  return Math.ceil(row + DESKTOP_TABS_GUTTER_PX);
}

module.exports = {
  HOMEOWNER_TAB_LABELS,
  HOMEOWNER_DESKTOP_TAB_IDS,
  HOMEOWNER_MORE_LINK_IDS,
  homeownerTabs,
  desktopTabRowWidth,
};
